import axios, { AxiosResponse } from 'axios';

import { ICovid19Payload } from './interfaces/ICovid19Payload';
import { Covid19DeclarationUrl } from '../../helpers/ConfigSettings';

export default class Covid19Service {

    public static fillCovid19FormWithId = async (id: string, callback: (result: ICovid19Payload | string, isSuccess: boolean) => void) => {
        await axios({
            method: 'POST',
            url: encodeURI(Covid19DeclarationUrl),
            data: { name: 'getInfo', code: id }
        }).then((response: AxiosResponse<any>) => {
            if (response.status === 200) {
                callback(response.data as ICovid19Payload, true);
            } else {
                callback(response.data as string, false);
            }
        }).catch((error) => {
            if (error.response !== undefined && error.response !== null) {
                callback(error.response.data, false);
            } else {
                callback('Connection error, please try again', false);
            }
        });
    }

    public static submitCovid19FormWithId = async (id: string, callback: (result: string, isSuccess: boolean) => void) => {
        await axios({
            method: 'POST',
            url: encodeURI(Covid19DeclarationUrl),
            data: { name: 'submitInfo', code: id }
        }).then((response: AxiosResponse<any>) => {
            if (response.status === 200) {
                callback(response.data, true);
            } else {
                callback(response.data, false);
            }
        }).catch((error) => {
            if (error.response !== undefined && error.response !== null) {
                callback(error.response.data, false);
            } else {
                callback('Connection error, please try again', false);
            }
        });
    }
}